import { API_AUTH } from "./common";

const InChoVayApi = {
  combo: ({}) => API_AUTH.get(`he-thong/mau-hop-dong`, {}),

  comboMauPhieuThuChi: (type) =>
  API_AUTH.get(
    `quan-ly-thu-chi/combo-mau-thu-chi?type=${type}`,
    {}
  ),

  getInChoVay: ({ mauhopdongId, chovayId }) =>
    API_AUTH.get(
      `quanlychovay/in-hop-dong-cam-do?mauhopdongId=${mauhopdongId}&chovayId=${chovayId}`,
      {}
    ),
  getInNhanVay: ({ nhanvayId, mauhopdongId }) =>
    API_AUTH.get(
      `quan-ly-nhan-vay/in-hop-dong-nhan-vay?nhanvayId=${nhanvayId}&mauhopdongId=${mauhopdongId}`,
      {}
    ),
  getInThuChi1: (thuchiId, tenMauIn) =>
    API_AUTH.get(
      `quan-ly-thu-chi/in-phieu-thu-chi?thuchiId=${thuchiId}&tenMauIn=${tenMauIn}`,
      {}
    ),
};

export default InChoVayApi;
